import React from "react";
import { Box, Button, Typography } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import OptionRow from "./OptionRow.";

function OptionsEditor({ q, updateOption, deleteOption, addOption, classes }) {
  const visibles = (q?.respuestas || []).filter((o) => o.__state !== "deleted");

  return (
    <Box>
      <Typography variant="subtitle1" className={classes.sectionTitle}>
        Opciones
      </Typography>

      {visibles.map((o) => (
        <OptionRow
          key={`opt-${o.id}`}
          qid={q.id}
          option={o}
          onCommit={updateOption}
          onDelete={deleteOption}
          classes={classes}
        />
      ))}

      <Button onClick={() => addOption(q.id)} startIcon={<Add />} size="small" color="primary">
        Agregar opción
      </Button>
    </Box>
  );
}

export default React.memo(OptionsEditor);
